import { gql } from '@apollo/client'

export const GET_MIGRANTS_GROUPS_CATEGORIES = gql`
  query GetMigrantsGroupsCategories(
    $limit: Int
    $offset: Int
    $searchQuery: String
  ) {
    getMigrantsGroupsCategories(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
    ) {
      rows {
        id
        name
        image_url
      }
      count
    }
  }
`
export const GET_MIGRANTS_REPORTS = gql`
  query GetMigrantsReports($limit: Int, $offset: Int, $user_id: Int) {
    getMigrantsReports(limit: $limit, offset: $offset, user_id: $user_id) {
      rows {
        id
        date
        process
        status {
          id
          name
          order
          progress
          type
          color
          description
        }
      }
      count
    }
  }
`

export const GET_MIGRANTS_REPORTS_BY_ID = gql`
  query GetMigrantsReportsById($getMigrantsReportsByIdId: Int!) {
    getMigrantsReportsById(id: $getMigrantsReportsByIdId) {
      id
      date
      process
      status {
        id
        name
        order
        progress
        type
        description
        color
      }
      invoice
      groupCategory {
        id
        name
      }
      groupCategorySub {
        id
        name
      }
      migrantsFormFields {
        label
        value
      }
      AttachmentsOfReport {
        id
        user_id
        url
        type_file
        label
      }
    }
  }
`

export const GET_MIGRANTS_FORM_BY_GROUPS_CATEGORY_SUB_ID = gql`
  query GetMigrantsFormByGroupsCategorySubId($group_category_sub_id: Int!) {
    getMigrantsFormByGroupsCategorySubId(
      group_category_sub_id: $group_category_sub_id
    ) {
      id
      name
      description
      diplay_name
      display_name_plural
      icon
      id_user_register
      GroupsCategoriesSubOfForm {
        id
        name
      }
      FieldsOfForm {
        id
        form_id
        label
        name
        placeholder
        field_type_id
        field_type_choosen_source_id
        order
        col_width
        file_types_allowed
        TypeOfField {
          id
          name
          description
          type
        }
        TypeChoosenSourceOfField {
          id
          source_table
          key
          label
          source_json
        }
        FieldYupRulesOfFormField {
          id
          field_id
          yup_rule_id
          YupRuleOfField {
            id
            description
            yup_type
            yup_rule
            options
            message
            active_on_web
          }
        }
      }
    }
  }
`

export const GET_MIGRANTS_GROUPS_CATEGORIES_SUBS = gql`
  mutation GetMigrantsGroupsCategoriesSubs($groupCategoryId: Int) {
    getMigrantsGroupsCategoriesSubs(group_category_id: $groupCategoryId) {
      id
      name
      image_url
    }
  }
`

export const GET_MIGRANTS_DATA_SOURCE_CHOOSEN = gql`
  mutation GetMigrantsDataSourceOfFormFieldTypeChoosenSource(
    $idFormFieldTypeChoosenSource: Int!
  ) {
    getMigrantsDataSourceOfFormFieldTypeChoosenSource(
      idFormFieldTypeChoosenSource: $idFormFieldTypeChoosenSource
    ) {
      value
      label
    }
  }
`

export const CREATE_MIGRANTS_REPORT = gql`
  mutation CreateMigrantsReport($input: inputMigrantReport!) {
    createMigrantsReport(input: $input)
  }
`
